import chatLoginReducer from './chatLoginReducer';
import playerReducer from './playerReducer';
import configurationReducer from './configurationReducer';
import shoppingReducer from './shoppingReducer';
import restrictionReducer from './restrictionReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
	chatLoginReducer,
	playerReducer,
	configurationReducer,
	shoppingReducer,
	restrictionReducer,
});

export default rootReducer;
